import { lazy } from 'react';

export const ProductList = lazy(() => import('./product/ProductList'));
export const AddProduct = lazy(() => import('./product/AddProduct'));
export const UpdateProduct = lazy(() => import('./product/UpdateProduct'));
export const ProductDetails = lazy(() => import('./product/ProductDetails'));
export const ProductReviews = lazy(() => import('./product/ProductReviews'));
export const PricingList = lazy(() => import('./pricing/PricingList'));
export const PricingConfiguration = lazy(() => import('./pricing/PricingConfiguration'));
export const RecipeList = lazy(() => import('./recipe/RecipeList'));
export const RecipeDetails = lazy(() => import('./recipe/RecipeDetails'));